<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Stock Opname Form
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter Items
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Stock As Of Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="header.tanggal" type="text" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Store/WareHouse</label>
                </b-input-group-prepend>
                <b-form-input v-model="header.namaStore" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Note/Description</label>
                </b-input-group-prepend>
                <b-form-input v-model="header.uraian" placeholder="Note/Description" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-form-checkbox
                v-model="showItemRecorded"
                value="1"
                unchecked-value="0"
                style="margin-left:10px;"
              >Show item recorded</b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="showFilter">
        <b-col md="3">
          <b-input-group>
            <b-input-group-prepend>
              <label>
                <strong>Filter -></strong> Shelf/Rack
              </label>
            </b-input-group-prepend>
            <!-- <b-form-input v-model="filter.shelfNo" placeholder="Shelf/Rack Number"></b-form-input> -->
            <b-form-select v-model="filter.shelfNo" :plain="true" :options="shelfList"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col class="pl-3 pr-1" md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Posting Category</label>
            </b-input-group-prepend>
            <b-form-select v-model="filter.itemcategory" :plain="true" :options="itemCategories"></b-form-select>
            <b-form-select v-model="filter.headcategory" :plain="true" :options="headCategories"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col class="pl-1" md="3">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Reload
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear Filter
            </b-button>
          </b-row>
        </b-col>
      </b-row>

      <div class="report-wraper">
        <table style="width: 99%;">
          <thead>
            <tr>
              <th width="20px">No.</th>
              <th width="180px">Item Code</th>
              <th>Item Name</th>
              <th width="300px">Type/Series</th>
              <th>Posting Category</th>
              <th>Shelf No</th>
              <th width="100px" style="text-align:center;">
                System
                <br />Quantity
              </th>
              <th width="250px" style="text-align:center;">
                Physical
                <br />Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row,index) in dataItems"
              :key="row.invOpnamDtlKey"
              @click.stop="confirmAction(row)"
              :class="{ selected: row.isSelected ,beforeOpname :row.qtyOpname===row.qtySystem?false:true }"
            >
              <td>{{index+1}}</td>
              <td>{{row.partnumber}}</td>
              <td>{{row.itemname}}</td>
              <td>{{row.itemno+' | '+row.itemname}}</td>
              <td>{{row.nmcategory}}</td>
              <td>{{row.shelfNo}}</td>
              <td style="text-align:center;">{{row.qtySystem}} {{row.invunitom}}</td>
              <td v-if="(row.isSelected==1)" style="text-align:center;">
                <b-input-group>
                  <b-form-input
                    v-model="model.qtyOpname"
                    type="number"
                    :state="!$v.model.qtyOpname.$error"
                    :min="0"
                  ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text">{{row.invunitom}}</span>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button variant="success" size="sm" @click.stop="save()">
                      <i class="fa fa-check"></i>Save
                    </b-button>
                    <b-button variant="danger" size="sm" @click.stop="unselect()">
                      <i class="fa fa-times"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </td>
              <td v-else style="text-align:center;">
                <span v-if="(row.qtyOpname !== null)">{{row.qtyOpname}} {{row.invunitom}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>
<style lang="scss">
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  min-height: 100px;
  border: 1px solid silver;
  table {
    font-size: smaller;
    th {
      border: 1px solid silver;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border: 1px solid silver;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }

    tbody tr.selected {
      background-color: rgba(70, 253, 70, 0.2) !important;
      cursor: default;
    }

    tbody tr.beforeOpname {
      background-color: #f2dddd !important;
      cursor: default;
    }
  }
}
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import opname from "../../apis/logistic_inv_opname";
import item from "../../apis/item";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      invOpnamDtlKey: { required },
      qtyOpname: { numeric, required }
    }
  },
  data() {
    return {
      saveEnabled: true,
      showFilter: false,
      showItemRecorded: "1",
      filter: {
        shelfNo: "",
        itemcategory: "",
        headcategory: ""
      },

      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      headCategories: [{ value: "", text: "-- ALL--" }],
      itemCategories: [{ value: "", text: "-- ALL--" }],
      shelfList: [{ value: "", text: "-- ALL--" }],
      model: { invOpnamDtlKey: "", qtyOpname: "" },
      header: {},
      dataDetail: [],
      dataItems: [] // <- data hasil filter
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    }
  },
  watch: {
    showItemRecorded: function(newVal) {
      setTimeout(() => {
        this.refresh();
      }, 100);
    },
    dataItems: function(val) {
      setTimeout(() => {
        let findIdx = val.findIndex(x => x.qtyOpname === null);
        this.confirmAction(this.dataItems[findIdx]);
      }, 100);
    }
  },
  created: async function() {
    const [a, b] = await Promise.all([item.headgroup(), item.group()]);
    a.forEach(el => {
      this.headCategories.push(el);
    });
    b.forEach(el => {
      this.itemCategories.push(el);
    });
    if (this.$route.params.invOpnamKey) {
      toastr.info("Loading Stock Opname Detail, please wait");
      this.data();
    }
  },
  methods: {
    data: async function() {
      try {
        const data = await opname.detail(this.$route.params);
        this.header = data[0][0];
        this.header.tanggal = moment(this.header.tanggal).format("DD MMM YYYY");
        this.dataDetail = data[1];

        data[1].forEach(element => {
          const findShelf = this.shelfList.find(
            x => x.value === element.shelfNo
          );
          if (!findShelf)
            this.shelfList.push({
              value: element.shelfNo,
              text: element.shelfNo
            });
        });
        // code below just for testing
        this.shelfList.push({ value: "test#1", text: "Testing" });
        this.refresh();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    confirmAction: function(record) {
      if (this.row) delete this.row.isSelected;
      this.row = record;
      record.isSelected = 1;
      for (var key in record) {
        this.model[key] = record[key];
      }
      this.$forceUpdate();
    },
    unselect: function() {
      if (this.row) delete this.row.isSelected;
      this.row = undefined;
      this.$forceUpdate();
    },
    refresh: async function() {
      let dataItems = this.dataDetail.reduce((arr = [], el, idx) => {
        if (this.showItemRecorded === "0" && el.qtyOpname === null) {
          arr.push(el);
        } else if (
          this.showItemRecorded === "1" &&
          (el.qtyOpname === null || el.qtyOpname !== null)
        ) {
          arr.push(el);
        }
        return arr;
      }, []);

      if (
        this.filter.headcategory ||
        this.filter.itemcategory ||
        this.filter.shelfNo
      ) {
        dataItems = dataItems.filter(el => {
          if (
            this.filter.headcategory &&
            this.filter.headcategory !== el.headcategory
          )
            return false;

          if (
            this.filter.itemcategory &&
            this.filter.itemcategory !== el.itemcategory
          )
            return false;

          if (this.filter.shelfNo && this.filter.shelfNo !== el.shelfNo)
            return false;

          return true;
        });
      }
      this.dataItems = dataItems;
    },
    save: async function() {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          //lakukan pangil API untuk Update ke Database disini

          if (this.row) {
            const data = await opname.posting(this.model);
            this.row.qtyOpname = this.model.qtyOpname;
          }
          this.unselect();
          this.data();
          // lebih baik ditambahkan untul autoselect Next Item , & ready to update
        } catch (error) {
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "Save Opname Item  Error");
        }
      }
    },
    clearFilter() {
      this.filter.shelfNo = "";
      this.filter.itemcategory = "";
      this.filter.headcategory = "";
      this.refresh();
    },
    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "procurement.receivingfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        // router.push({name:'payable.apinv'});
        router.push("home");
      }
    }
  }
};
</script>
